module.exports = __webpack_public_path__ + "assets/img/78bf543021221af132eaeb4d8d744c45.png";